"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceSubject = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../../../../common");
const server_1 = require("../../../../../server");
const throttle_1 = __importDefault(require("lodash/throttle"));
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const default_drop = { id: 'select', title: 'assignment.selectSubject' };
exports.ChoiceSubject = react_1.default.memo(({ test_id, subjectId, setSubjectId }) => {
    const { isDesktop, isTablet, isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [dropValue, setDropValue] = react_1.default.useState(subjectId ? { id: subjectId, title: subjectId } : default_drop);
    const [dropList, setDropList] = react_1.default.useState([]);
    const { data, refetch } = (0, server_1.useGradesList)({
        test_id,
        member_id: '',
        orderby: ["IF(subject_item='공통',0,1)", 'subject_item'],
    });
    const refetchList = (0, throttle_1.default)(refetch, 1000, { leading: true, trailing: false });
    (0, react_1.useEffect)(() => {
        refetchList();
    }, [test_id]);
    (0, react_1.useEffect)(() => {
        if (!data)
            return;
        const { total_count, items } = data;
        if (total_count === 0) {
            setDropList([default_drop]);
            return;
        }
        const list = items
            .map(({ subject_item }) => ({
            id: subject_item,
            title: subject_item,
        }))
            .filter(item => item.id !== '');
        setDropList([default_drop, ...list]);
    }, [data]);
    (0, react_1.useEffect)(() => {
        setSubjectId(dropValue.id === 'select' ? undefined : dropValue.id);
    }, [dropValue.id]);
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('RESET_SUBJECT', refetchList);
        return () => {
            APP.eventManager.unsubscribe('RESET_SUBJECT', refetchList);
        };
    }, []);
    return (react_1.default.createElement(common_1.DropDown, { className: `dropdown-${isMobile ? 'mobile-small' : isTablet ? 'tablet' : 'small'} `, value: dropValue, list: dropList, setDropValue: setDropValue, styles: {
            dropWrap: {
                width: isMobile ? 148 : 184,
                alignSelf: isMobile ? 'flex-end' : 'flex-start',
            },
            itemWrap: {
                maxHeight: 300,
                top: isMobile && 44,
            },
        } }));
});
